import React, { useEffect, useRef } from 'react'
import { Platform, AppState } from 'react-native'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import HomeScreen from '../screens/HomeScreen'
import NewSaleScreen from '../screens/NewSale/NewSaleScreen'
import SalesHistoryScreen from '../screens/SalesHistory/SalesHistoryScreen'
import SaleDetailScreen from '../screens/SalesHistory/SaleDetailScreen'
import ReturnSaleScreen from '../screens/SalesHistory/ReturnSaleScreen'
import AddCartItemScreen from '../screens/NewSale/AddCartItemScreen'
import EditCartItemScreen from '../screens/NewSale/EditCartItemScreen'
import ProductsScreen from '../screens/Products/ProductsScreen'
import ProductDetailScreen from '../screens/Products/ProductDetailScreen'
import AddIngredientToProductScreen from '../screens/Products/AddIngredientToProductScreen'
import ProductStockMovementScreen from '../screens/ProductStocks/ProductStockMovementScreen'
import WriteOffsScreen from '../screens/WriteOffs/WriteOffsScreen'
import WriteOffDetailScreen from '../screens/WriteOffs/WriteOffDetailScreen'
import ManufacturesScreen from '../screens/Manufacture/ManufacturesScreen'
import ManufactureDetailScreen from '../screens/Manufacture/ManufactureDetailScreen'
import TransfersScreen from '../screens/Transfers/TransfersScreen'
import TransferDetailScreen from '../screens/Transfers/TransferDetailScreen'
import ClientOrdersScreen from '../screens/ClientOrders/ClientOrdersScreen'
import ClientOrderDetailScreen from '../screens/ClientOrders/ClientOrderDetailScreen'
import ComplexSalesScreen from '../screens/ComplexSales/ComplexSalesScreen'
import ComplexSaleDetailScreen from '../screens/ComplexSales/ComplexSaleDetailScreen'
import ComplexSaleTemplatesScreen from '../screens/ComplexSales/ComplexSaleTemplatesScreen'
import SuppliesScreen from '../screens/IncomingSupplies/SuppliesScreen'
import { SupplyDetailScreen } from '../screens/IncomingSupplies/SupplyDetailScreen'
import PaymentStatsScreen from '../screens/Payments/PaymentStatsScreen'
import PaymentTransactionDetailScreen from '../screens/Payments/PaymentTransactionDetailScreen'
import PaymentTransactionsScreen from '../screens/Payments/PaymentTransactionsScreen'
import SpendingsScreen from '../screens/Spendings/SpendingsScreen'
import SpendingDetailScreen from '../screens/Spendings/SpendingDetailScreen'
import RecurringSpendingDetailScreen from '../screens/Spendings/RecurringSpendingDetailScreen'
import ProductStocksScreen from '../screens/ProductStocks/ProductStocksScreen'
import UniversalListScreen from '../components/UniversalListScreen'
import EditableListScreen from '../components/EditableListScreen'
import OrgDetailScreen from '../screens/Settings/OrgDetailScreen'
import StoreDetailScreen from '../screens/Settings/StoreDetailScreen'
import LoyaltySettingsScreen from '../screens/Settings/LoyaltySettingsScreen'
import MarketplaceSettingsScreen from '../screens/Settings/MarketplaceSettingsScreen'
import PrintSettingsScreen from '../screens/Settings/PrintSettingsScreen'
import SaleSettingsScreen from '../screens/Settings/SaleSettingsScreen'
import WalletDetailScreen from '../screens/Settings/WalletDetailScreen'
import ProductUnitDetailScreen from '../screens/Settings/ProductUnitDetailScreen'
import PaymentMethodDetailScreen from '../screens/Settings/PaymentMethodDetailScreen'
import PurchaseMethodDetailScreen from '../screens/Settings/PurchaseMethodDetailScreen'
import PriceTypesScreen from '../screens/Settings/PriceTypesScreen'
import RoleDetailScreen from '../screens/Settings/RoleDetailScreen'
import ProductModifiersDetailScreen from '../screens/Settings/ProductModifiersDetailScreen'
import UserDetailScreen from '../screens/Settings/UserDetailScreen'
import SupplierDetailScreen from '../screens/Settings/SupplierDetailScreen'
import StatsScreen from '../screens/Stats/StatsScreen'
import ShiftScreen from '../screens/Shift/ShiftScreen'
import { CashboxTransactionScreen } from '../screens/Shift/CashboxTransactionScreen'
import SettingsScreen from '../screens/Settings/SettingsScreen'
import ChooseStoreScreen from '../screens/Profile/ChooseStoreScreen'
import ProfileScreen from '../screens/Profile/ProfileScreen'
import SalaryScreen from '../screens/Profile/SalaryScreen'
import ProductCategoriesScreen from '../screens/Settings/ProductCategoriesScreen'
import RevisionsScreen from '../screens/Revisions/RevisionsScreen'
import RevisionDetailScreen from '../screens/Revisions/RevisionDetailScreen'
import ClientsScreen from '../screens/Clients/ClientsScreen'
import ClientDetailScreen from '../screens/Clients/ClientDetailScreen'
import MarketingListsScreen from '../screens/ClientSegmentation/MarketingListsScreen'
import MarketingListDetailScreen from '../screens/ClientSegmentation/MarketingListDetailScreen'
import CreateMarketingListScreen from '../screens/ClientSegmentation/CreateMarketingListScreen'
import ChooseProductScreen from '../screens/ClientSegmentation/ChooseProductScreen'
import MiscScreen from '../screens/Admin/MiscScreen'
import DatabaseWriteLogsScreen from '../screens/Admin/DatabaseWriteLogsScreen'
import BillingScreen from '../screens/Billing/BillingScreen'
import ResetDataScreen from '../screens/Settings/ResetDataScreen'
import ExportImportScreen from '../screens/Settings/ExportImportScreen'
import SalesImportScreen from '../screens/Settings/SalesImportScreen'
import ManufactureImportScreen from '../screens/Settings/ManufactureImportScreen'
import PrintStickersScreen from '../screens/PrintStickers/PrintStickersScreen'
import AddProductStickerScreen from '../screens/PrintStickers/AddProductStickerScreen'
import StickerPrinterSettingsScreen from '../screens/PrintStickers/StickerPrinterSettingsScreen'
import SellerChecklistScreen from '../screens/Checklists/SellerChecklistScreen'
import UpdatesScreen from '../screens/Updates/UpdatesScreen'
import ShiftsStats from '../screens/Stats/ShiftsStats'
import ProfitStats from '../screens/Stats/ProfitStats'
import SalesStats from '../screens/Stats/SalesStats'
import RevisionStats from '../screens/Stats/RevisionStats'
import ProductStats from '../screens/Stats/ProductStats'
import ComplexSaleStats from '../screens/ComplexSales/ComplexSaleStats'
import EditDailyStatsScreen from '../screens/Stats/EditDailyStatsScreen'
import * as Notifications from 'expo-notifications'
import { getStatsForDays, rootDb, auth } from './Firebase/firebase'
import { usersApi } from './API/typedApiClient'
import Spinner from '../components/Spinner'
import { FloatingButtonWithModal } from '../components/FloatingButtonWithModal'
import * as Sentry from "@sentry/react-native"
import { setFBAnalyticsUserId, setFBAnalyticsUserProperties } from './Firebase/firebaseAnalytics'
import { usePostHog } from 'posthog-react-native'
import { captureOperationalEvent, registerOperationalTelemetrySink } from './analytics/operationalTelemetry'
import { reportWriteBundleCapability } from './analytics/writeBundleCapability'
import { reportSessionWriteMode } from './analytics/writeModeTelemetry'
import { reportMirrorIntentSession } from './analytics/mirrorIntentTelemetry'
import { pinSessionWriteModeAtStartup } from './Write/writeW'
import { writesMasterMemory } from './Write/writesMasterMemory'
import { decideStartupOutboxLook } from './Write/writeMode'
import { abandonLocalViewRead, beginLocalViewRefetch, commitLocalViewRead, commitLocalViewReadIfCurrent, localViewStartupBarrier, openLocalViewStartupBarrier, refreshLocalViewDay, registerLocalViewReadRequester } from './Write/localView'
import { WRITE_W_CAPABILITY } from './Write/writeWCapability'
import { probeOutboxV2Presence, stopSessionOutboxV2, triggerActiveSessionOutboxV2 } from './Write/sessionOutboxV2'
import { createAppWritePlane, startSessionOutboxAfterPin } from './Write/writeCutoverSession'
import { useToast } from "react-native-toast-notifications"
import { useTranslation } from 'react-i18next'
import { useAtom, useSetAtom, useAtomValue, getDefaultStore } from 'jotai'
import { constantsAtom, serverDailyStatsAtom, discountOptionsListAtom, organizationAtom, productCategoriesDictAtom, serverProductsDictAtom, productsUpdatedAtom, productUnitsDictAtom, rolesDictAtom, storesDictAtom, suppliersDictAtom, userRoleAtom, usersDictAtom, dbAtom, userAtom, organizationSubscriptionInfoAtom, inactiveUsersAtom, printTemplatesAtom } from './AtomsProvider'
import {
  fetchProductsFromSupabase,
  fetchProductCategoriesFromSupabase,
  fetchStoresFromSupabase,
  fetchUsersFromSupabase,
  fetchSuppliersFromSupabase,
  fetchPrintTemplatesFromSupabase,
  fetchConstantsFromSupabase,
  fetchDailyStatsFromSupabase,
  fetchShiftReportFromSupabase,
  fetchOrganizationFromSupabase,
} from '../utils/supabaseDataHelpers'
import { loadInitialSupabaseData, SupabaseInitialLoadError } from './Supabase/initialLoad'
import { setupAllSubscriptions, cleanupPendingRefetches } from './Supabase/subscriptionFactory'
import { createRealtimeChannel, unsubscribeChannel } from '../global/Supabase/supabaseClient'
import { createDailyStatsFreshness } from '../global/Supabase/dailyStatsFreshness'
import { shouldFetchShiftReport } from '../global/Supabase/shiftReportAccess'
import { planDailyStatsBusinessDays, readTodayDailyStats, readTodayShiftStats } from '../global/Supabase/dailyStatsBusinessDays'
import { dateRangeWithTimezoneAndAutoclose, getLocalStoreDate, getStoreBusinessDate, getDailyStatID } from '../utils/timezoneFunctions'
import { saveProductStockSnapshot } from '../utils/validationFunctions'
import { shouldUseSupabase, snapshotExists, getOrganization, getDeviceSupabaseOverride } from './Firebase/types'
import { primeOrganizationForReadCutover } from './Firebase/orgReadCutover'
import {
  watchOrganizationReadCutover,
  performLiveRollback,
  LIVE_ROLLBACK_GRACE_MS,
  LIVE_ROLLBACK_DRAIN_CAP_MS,
} from './Firebase/orgReadCutoverWatch'
import { waitForWritesToDrain } from './API/writesInFlight'
import { reloadApp } from './Firebase/reloadApp'
import { localDevSupabaseReads } from './config/supabaseReads'
import { shouldDualWrite, allowlistRawForTelemetry } from './Firebase/dualWrite'
import { supportChatOpenRequestAtom } from './Support/supportUnread'
import {
  osSupportBannerAtom,
  bannerAfterPermissionStep,
  bannerAfterTokenStep,
  applyTokenVerdict,
  useOsSupportBannerRefresh,
} from './Support/osSupportBanner'
import { shouldUseNativeSupportChat, __setNativeSupportChatResolver } from './Support/supportFlag'
import { isOrgSupportChatEnabled } from './Support/supportAllowlist'
import { remoteConfigReady, refetchRemoteConfig } from './Firebase/firebaseFirestore'
import * as Device from 'expo-device'
import PaywallScreen from '../screens/Billing/PaywallScreen'
import LegalScreen from '../screens/Settings/LegalScreen'
import ApiTokensScreen from '../screens/Settings/ApiTokensScreen'
import AgentDraftsScreen from '../screens/Settings/AgentDraftsScreen'
import AiAssistantsScreen from '../screens/Settings/AiAssistantsScreen'
import ConnectAiScreen from '../screens/Settings/ConnectAiScreen'
import { CURRENCIES } from '../utils/currencies'
import { buildOrganizationAnalyticsGroup, resolveOrganizationCurrency } from '../utils/organizationAnalytics'
import { useNavigationState } from '@react-navigation/native'
import BatchProductEditScreen from '../screens/Products/BatchProductEditScreen'
import SupplyOrdersScreen from '../screens/SupplyOrders/SupplyOrdersScreen'
import SupplyOrderDetailScreen from '../screens/SupplyOrders/SupplyOrderDetailScreen'
import DualWriteTestScreen from '../screens/Admin/DualWriteTestScreen'
import BlockedScreen from '../components/BlockedScreen'
import { useVersionCheck } from '../hooks/useVersionCheck'

const Stack = createNativeStackNavigator()

export default function AppStack() {
  const { t } = useTranslation()
  const { isBlocked, isLoading: versionLoading, config: versionConfig } = useVersionCheck()
  // ATL-1445 stage 3 P6: every writer sets the SERVER atoms; `dailyStatsAtom`/`productsDictAtom` are
  // derived from them (server + this device's unsent writes) and read-only.
  const setDailyStats = useSetAtom(serverDailyStatsAtom)
  const setOrganization = useSetAtom(organizationAtom)
  const setUsersDict = useSetAtom(usersDictAtom)
  const setInactiveUsers = useSetAtom(inactiveUsersAtom)
  const [storesDict, setStores] = useAtom(storesDictAtom)
  const user = useAtomValue(userAtom)
  const userRole = useAtomValue(userRoleAtom)
  const rolesDict = useAtomValue(rolesDictAtom)
  const organizationSubscriptionInfo = useAtomValue(organizationSubscriptionInfoAtom)
  const setProductsDict = useSetAtom(serverProductsDictAtom)
  const setProductsUpdated = useSetAtom(productsUpdatedAtom)
  const setRoles = useSetAtom(rolesDictAtom)
  const setProductCategories = useSetAtom(productCategoriesDictAtom)
  const setDiscountOptionsList = useSetAtom(discountOptionsListAtom)
  const setSuppliersDict = useSetAtom(suppliersDictAtom)
  const setConstants = useSetAtom(constantsAtom)
  const setProductUnitsDict = useSetAtom(productUnitsDictAtom)
  const setPrintTemplates = useSetAtom(printTemplatesAtom)
  const setSupportChatOpenRequest = useSetAtom(supportChatOpenRequestAtom)
  // ATL-1345: the push prompt below reports whether the OS will show its own banner for a support
  // reply, so the in-app toast can stand down where it would only duplicate that banner.
  const setOsSupportBanner = useSetAtom(osSupportBannerAtom)
  useOsSupportBannerRefresh()
  const organization = useAtomValue(organizationAtom)
  const notificationListener = useRef()
  const responseListener = useRef()
  const appState = useRef(AppState.currentState)
  const today = useRef()
  const db = useAtomValue(dbAtom)
  const toast = useToast()
  const networkToastID = useRef()
  const hasPendingWrites = useRef()
  const unsubscribeDailyStats = useRef()
  // ATL-1165: resynchronises `dailyStatsAtom` on foreground. Null in Firestore
  // mode, where `onSnapshot` re-delivers current state on reconnect by itself.
  const refetchDailyStats = useRef(null)
  // ATL-1165: monotonic generation for the Supabase daily-stats fetches.
  // `subscribeToDailyStats` re-runs on business-day rollover and on a read-mode
  // flip, but an in-flight fetch cannot be cancelled — and `setDailyStats`
  // REPLACES the per-store entry rather than merging it. So a fetch issued just
  // before midnight that resolves just after it would overwrite the new day's
  // totals with D-1's, on a screen people read to pay staff. A fetch whose
  // generation is stale therefore discards its result instead of writing it.
  const dailyStatsGeneration = useRef(0)
  const unsubscribeOthers = useRef()
  // ATL-1405: which `getInitialData` run is current. See `teardownInitialDataSubscriptions`.
  const initialDataRun = useRef(0)
  const runOnceRef = useRef(false)
  const subscriptionContextRef = useRef(null) // Context for subscription factory (includes pending refetches)
  // ATL-888: what this session ACTUALLY chose as its data source, recorded at the branch itself.
  // `null` until `getInitialData` has decided. The live-rollback watch compares against this rather
  // than re-evaluating `shouldUseSupabase()`, because the thing it must detect is precisely a
  // divergence between the flag and what the session did — and re-reading the flag cannot see that.
  const sessionReadsSupabaseRef = useRef(null)
  // The live-rollback watch handle (ATL-888), so `getInitialData` can tell it the session has
  // finally chosen a data source and any observation taken before that can be re-decided.
  const readCutoverWatchRef = useRef(null)
  const navigationState = useNavigationState(state => state);
  const postHog = usePostHog()
  // ATL-1354 — hand the client to the non-React modules. `supabaseClient` and `dualWriteOutbox` are
  // plain modules and can never call a hook, so without this their operational telemetry has
  // nowhere to go. Anything they captured before this runs (the app-start outbox drain, typically)
  // is buffered and flushed here rather than lost.
  useEffect(() => {
    registerOperationalTelemetrySink(postHog)
  }, [postHog])
  // ATL-1445 stage 3 (P0) — the `write-bundle-coverage` gate clause's evidence: which bundle this
  // process runs and whether it could honour a write cutover. Once per process per organization
  // (the module de-duplicates); an event rather than a super property so an older bundle launched
  // later cannot inherit a newer bundle's answer — see analytics/writeBundleCapability.ts.
  useEffect(() => {
    reportWriteBundleCapability(user?.organizationId)
  }, [user?.organizationId])
  const screensWithoutFloatingButton = [
    'AddCartItem',
  ];

  const shouldShowFloatingButton = () => {
    if (user?.role !== 'admin') return false
    if (!navigationState || !Array.isArray(navigationState.routes)) return false
    const index = typeof navigationState.index === 'number' ? navigationState.index : 0
    const currentRoute = navigationState.routes[index]
    const currentRouteName = currentRoute?.name || currentRoute?.routeName
    if (!currentRouteName) return false
    return !screensWithoutFloatingButton.includes(currentRouteName)
  };

  useEffect(() => {
    if (db && user.store?.id) {
      getInitialData()
    }
  }, [db, user])

  // ATL-888 — the live rollback. Arms the read-cutover kill switch for the life of the session.
  //
  // Deliberately its OWN effect, keyed on the organization ID alone:
  //   * it must NOT be folded into the `[db, user]` effect above — that effect reloads all data and
  //     rebuilds every subscription, and giving it another dependency is how a re-render turns into
  //     a full data reload. (It is also the effect whose missing `organization` dependency made
  //     ATL-886 possible; the fix is a separate watcher, not another dependency on that one.)
  //   * it must NOT depend on `organization`, or it would tear down and re-attach the listener on
  //     every unrelated edit to the org document — including the ones it is watching for.
  //
  // The watch runs in BOTH read modes and reads Firestore in both. See orgReadCutoverWatch.ts for
  // why the kill switch must not be delivered over the store it may be killing.
  useEffect(() => {
    const organizationId = user?.organizationId
    if (!organizationId) return

    let cancelPendingReload = null

    const watch = watchOrganizationReadCutover({
      organizationId,
      readSessionReadsSupabase: () => sessionReadsSupabaseRef.current,
      readDeviceOverride: getDeviceSupabaseOverride,
      readLocalDev: localDevSupabaseReads,
      subscribe: (orgId, onNext, onError) =>
        rootDb.collection('organizations').doc(orgId).onSnapshot(onNext, onError),
      // In Supabase read mode `organizationAtom` is refilled from the SUPABASE copy of the org, so
      // this resolves the flag from a different store than the watch does. Comparing them is how a
      // drift between the two halves of the dual-write becomes visible instead of silent.
      readLiveResolvedSupabase: shouldUseSupabase,
      // The two halves of the dual-written flag disagree, or the Supabase copy the running session
      // gates on has drifted from the Firestore copy this watch reads. Reported, never acted on —
      // acting would be acting on a guess about which half is right.
      onFlagDivergence: (detail) => {
        console.error('📊 [read-cutover] FLAG DIVERGENCE', { organizationId, ...detail })
        try {
          // ATL-1354: a divergence between the two halves of the dual-written flag is a
          // MEASUREMENT — how many tills, which direction, starting when. It was a
          // `Sentry.captureMessage` at `error` level, and it is reported but never acted on, so it
          // could never carry a stack worth reading. It now goes where it can be counted; the
          // breadcrumb keeps it visible on whatever throws next, for free.
          Sentry.addBreadcrumb({
            category: 'read_cutover.flag',
            level: 'error',
            message: 'read-cutover flag divergence',
            data: { organizationId, ...detail },
          })
          // Deliberately WITHOUT `organizationId`: PostHog already carries it as a person property
          // (`person.properties.organizationId` is how the cutover gate's own queries select an
          // organization), so repeating it here would be the same redundancy `channelTables()`
          // strips from the realtime event. It stays on the breadcrumb above, where Sentry has no
          // equivalent grouping. `detail` is four booleans — see orgReadCutoverWatch.
          captureOperationalEvent('read_cutover_flag_divergence', {
            read_cutover_flag_divergence: true,
            ...detail,
          })
        } catch (e) {
          console.warn('[read-cutover] divergence telemetry failed', e)
        }
      },
      onReload: (action) => {
        // Telemetry BEFORE the restart, inside a grace period long enough for it to leave the
        // device. ATL-887's lesson in reverse: a cutover is per-device, so "the operator flipped
        // the switch" says nothing about how many tills acted on it. Without this, a switch's
        // actual reach is unmeasurable — the blind spot that made the 6–7 Aug cutovers look real.
        try {
          // ATL-1354: this was ALSO a `Sentry.captureMessage` — one billable event per till per
          // cutover flip, during a ramp, duplicating the PostHog capture on the very next line.
          // A breadcrumb keeps it on whatever throws next; PostHog keeps it countable.
          Sentry.addBreadcrumb({
            category: 'read_cutover.reload',
            level: 'warning',
            message: `read-cutover live ${action}`,
            data: { organizationId, action },
          })
          postHog?.capture?.('read_cutover_live_reload', { organizationId, action })
        } catch (e) {
          // Never let an observability failure stop the kill switch.
          console.warn('[read-cutover] reload telemetry failed', e)
        }

        cancelPendingReload = performLiveRollback({
          notify: () =>
            toast.show(
              action === 'rollback'
                ? 'Источник данных возвращён на Firestore. Приложение перезапустится через несколько секунд.'
                : 'Организация переключена на Supabase. Приложение перезапустится через несколько секунд.',
              { type: 'warning', duration: LIVE_ROLLBACK_GRACE_MS }
            ),
          reload: reloadApp,
          // ATL-889: let in-flight dual-writes finish first. Capped — a hung request must not be
          // able to veto the kill switch — and it reports loudly if the cap expires.
          awaitDrain: () => waitForWritesToDrain({ capMs: LIVE_ROLLBACK_DRAIN_CAP_MS }),
        })
      },
      // ATL-1445 stage 3 (P5): the WRITE flag rides on this same listener. A session whose writes stay
      // Firestore-master (every organization today) is decided exactly as above; the write plane only
      // acts on a server-confirmed `writesMaster` that changes this session's write mode, and runs its
      // own restart (global/Write/writeCutoverWatch.ts: the capped write cutover, or the drain of
      // outbox v2 to empty before any restart onto Firestore).
      writePlane: createAppWritePlane({
        organizationId,
        showToast: (message, options) => toast.show(message, options),
        reload: reloadApp,
        onMasterRecheck: () => readCutoverWatchRef.current?.reevaluateWritePlane(),
        register: (properties) => postHog?.register?.(properties),
      }),
    })

    // The flip can land between this listener attaching and `getInitialData` recording the session's
    // data source. Without this, that observation would be the only one the device ever sees and it
    // would be discarded for arriving too early.
    readCutoverWatchRef.current = watch

    return () => {
      readCutoverWatchRef.current = null
      if (cancelPendingReload) cancelPendingReload()
      watch.unsubscribe()
      // P5: sign-out / org switch. Not awaited: the next drainer for the org is the one that waits.
      void stopSessionOutboxV2(organizationId)
    }
  }, [user?.organizationId])

  // Gate the native support chat on the current org's membership in the Remote Config allowlist
  // (`native_support_chat_org_allowlist`, mirrors `dual_write_org_allowlist`). The resolver is read
  // synchronously by shouldUseNativeSupportChat(); re-set it on org change so a switch re-evaluates.
  useEffect(() => {
    __setNativeSupportChatResolver(() => isOrgSupportChatEnabled(organization))
  }, [organization])

  useEffect(() => {
    if (Platform.OS !== 'web') {
      registerForPushNotificationsAsync().then(token => {
        if (!token) return

        // Firestore (legacy) and Supabase writes are independent: the backend's per-user push
        // reads users.push_token from Supabase, so a Firestore failure must NOT skip the Supabase sync.
        try {
          user?.ref?.update?.({ pushToken: token })
        } catch (e) {
          Sentry.captureException(e, { tags: { push_token_firestore_sync: true } })
        }

        // ATL-1345: the backend pushes to `users.push_token` in Supabase, not to this device's
        // token. A token the backend never stored produces no banner, so a sync that did not land
        // hands the announcement back to the in-app toast (a downgrade only — never suppresses).
        if (!user?.id) {
          setOsSupportBanner('not-shown')
          return
        }
        usersApi.updatePushToken(user.id, token).catch((e) => {
          console.warn('Supabase push-token sync failed:', e?.message)
          Sentry.captureException(e, { tags: { push_token_supabase_sync: true } })
          setOsSupportBanner('not-shown')
        })
      }).catch((e) => {
        Sentry.captureException(e, { tags: { push_token_register_reject: true } })
        // ATL-1345: a rejection here comes from the permission step, before any verdict was
        // published. Leaving the toast waiting on `unknown` would silence it on this device for the
        // whole session, so fail toward the toast.
        setOsSupportBanner('not-shown')
      })
    }

    // This listener is fired whenever a notification is received while the app is foregrounded
    notificationListener.current = Notifications.addNotificationReceivedListener(notification => {
      console.log('Received notification:', notification);
    });

    // This listener is fired whenever a user taps on or interacts with a notification
    responseListener.current = Notifications.addNotificationResponseReceivedListener(response => {
      console.log('Notification response:', response);
      try {
        const data = response?.notification?.request?.content?.data;

        // Handle notification tap based on type
        if (data?.type === 'new_order') {
          // Navigate to order details if needed
          // navigation.navigate('ClientOrders');
        } else if (data?.type === 'support' && shouldUseNativeSupportChat()) {
          // Open the native support chat panel.
          // conversationId is available in data.conversationId if needed in the future;
          // currently the chat panel resolves the active conversation via getOrCreateConversation.
          setSupportChatOpenRequest(true)
        }
      } catch (err) {
        // Malformed payload — log and ignore; never crash on notification handling.
        console.warn('Notification response handler error:', err)
      }
    });

    // Configure notification handler
    Notifications.setNotificationHandler({
      handleNotification: async () => ({
        shouldShowAlert: true,
        shouldPlaySound: true,
        shouldSetBadge: true,
      }),
    });
  
    return () => {
      Notifications.removeNotificationSubscription(notificationListener.current);
      Notifications.removeNotificationSubscription(responseListener.current);
      if (unsubscribeDailyStats.current?.length > 0) {
        for (let unsubscribe of unsubscribeDailyStats.current) {
          unsubscribe();
        }
      }
      if (unsubscribeOthers.current?.length > 0) {
        for (let unsubscribe of unsubscribeOthers.current) {
          unsubscribe();
        }
      }
      // Clear pending product refetches and stop in-flight ones writing after unmount
      if (subscriptionContextRef.current) {
        cleanupPendingRefetches(subscriptionContextRef.current);
      }
    }
  }, [])

  useEffect(() => {
     // check if app opened next day - then we need to update all the data
     const subscription = AppState.addEventListener("change", nextAppState => {
      if (
        appState.current.match(/inactive|background/) &&
        nextAppState === "active"
      ) {
        let storeToday = getStoreBusinessDate()
        // `toDateString()`, not `getDay()`. `getDay()` is the day of the WEEK, so a device that
        // was backgrounded for exactly 7 (or 14, or 21) days came back reporting the same day and
        // this branch never fired: the daily-stats listeners stayed pinned to the old day's
        // documents and — since ATL-1123 — `saveProductStockSnapshot` never ran, losing that day's
        // opening stock for every store. A calendar-day comparison cannot alias.
        //
        // `getStoreBusinessDate`, not `getLocalStoreDate`: everything this branch resubscribes is
        // keyed by the store's AUTOCLOSE-AWARE business day — the daily-stats listener below
        // subscribes to `getDailyStatID(storeId, new Date())`, and `saveProductStockSnapshot`
        // writes `<getDailyStatID>-stock`. Gating them on the calendar day desynchronises the two
        // for any store with an autoclose cutoff: foregrounding at 01:30 in a store that closes at
        // 04:00 flips the calendar day while the business day is still D-1, so this branch fires,
        // re-subscribes to D-1 (already snapshotted, nothing to write) and stamps `today.current`
        // with the NEW calendar day — after which business day D never trips the comparison at
        // all. Its stock snapshot is never taken and the home screen reads yesterday's daily stats
        // for the rest of the day. Same defect class as ATL-674.
        if (storeToday.toDateString() !== today.current?.toDateString()) {
          subscribeToDailyStats(storesDict)
        } else {
          // ATL-1165: same business day, so the subscriptions are still the
          // right ones — but a suspended app had its socket closed by the OS
          // and its timers frozen, and realtime-js only notices after a missed
          // heartbeat. The channel can therefore still read SUBSCRIBED while
          // the cache is already behind, and `postgres_changes` will never
          // replay what landed meanwhile. Resync explicitly.
          void refetchDailyStats.current?.()
        }
        // ATL-531/533: Remote Config can change while backgrounded (dual-write kill-switch /
        // org allowlist edits). Refetch on foreground and re-register the gate state so the
        // dual_write_eligible super property tracks the live gate, not the boot snapshot.
        void refetchRemoteConfig().then(rcStatus =>
          postHog.register({ dual_write_eligible: shouldDualWrite(), rc_status: rcStatus, dual_write_allowlist_raw: allowlistRawForTelemetry() }),
        ).catch(() => {})
        // ATL-1445 stage 3 (P5): "an immediate retry on foreground" (stage-3 §2) for the session's
        // outbox v2 drainer. A no-op unless one is running, which needs outbox v2 to hold something —
        // never for an organization today. Last, so the steps above keep their order; never throws.
        // No organization argument: this handler's `user` is the one of the render that armed it.
        triggerActiveSessionOutboxV2('foreground')
      }
      appState.current = nextAppState
    })
    return () => {
      subscription.remove()
    }
  }, [storesDict[user.store.id]?.localDate])

  async function registerForPushNotificationsAsync() {
    let token;

    if (!Device.isDevice) {
      console.log('Must use physical device for Push Notifications');
      // ATL-1345: no device, no token, no banner — the in-app toast is the only announcement.
      setOsSupportBanner('not-shown');
      return null;
    }

    // Check if we have permission
    const existingPerms = await Notifications.getPermissionsAsync();
    let perms = existingPerms;

    if (existingPerms.status !== 'granted') {
      // Request permission (iOS only prompts once per install; a prior denial returns
      // status='denied', canAskAgain=false without re-prompting)
      perms = await Notifications.requestPermissionsAsync();
    }

    // ATL-1345: publish the permission verdict BEFORE asking for a token, so a slow token request
    // cannot leave the in-app toast waiting. This is the PM's rule (push on ⇒ no toast); the token
    // outcome below can only relax it.
    setOsSupportBanner(bannerAfterPermissionStep(perms));

    if (perms.status !== 'granted') {
      console.log('Failed to get push token for push notification! Permission not granted.');
      return null;
    }

    const projectId = 'c8a61326-b027-4e88-af2c-425f55de20f4'; // EAS projectId (app.json)
    try {
      // Get the token
      const tokenData = await Notifications.getExpoPushTokenAsync({ projectId });

      token = tokenData.data;

      // Set up Android channel
      if (Platform.OS === 'android') {
        await Notifications.setNotificationChannelAsync('default', {
          name: 'default',
          importance: Notifications.AndroidImportance.MAX,
          vibrationPattern: [0, 250, 250, 250],
          lightColor: '#FF231F7C',
          sound: true,
          enableVibrate: true,
          showBadge: true,
        });
      }

      // Only now can the backend actually push to this device. Applied as a downgrade-only update:
      // `perms` was read before the (possibly slow) token request, and a foreground re-read may
      // since have seen push switched off — this stale reading must not upgrade that back.
      const tokenVerdict = bannerAfterTokenStep(perms, Boolean(token));
      setOsSupportBanner((current) => applyTokenVerdict(current, tokenVerdict));
      return token;
    } catch (error) {
      // A throw here is usually a native-build problem (missing aps-environment entitlement / no
      // APNs key for this build) or a projectId mismatch — it means the device can never get a
      // push token, so capture the real reason.
      console.error('Error getting push token:', error);
      Sentry.captureException(error, { tags: { push_token_get_expo: true } });
      // Granted, but no token means the backend has nothing to push to: no banner will come.
      setOsSupportBanner(bannerAfterTokenStep(perms, false));
      return null;
    }
  }

  const subscribeToDailyStats = (storeIdsDict, storesForMapping = null, useSupabaseParam = null) => {
    // Use passed stores for ID mapping, fallback to storesDict from closure (may be stale)
    const storesForLookup = storesForMapping || storesDict
    // Use passed useSupabase param if provided, otherwise check the setting
    const useSupabase = useSupabaseParam !== null ? useSupabaseParam : shouldUseSupabase()

    if (unsubscribeDailyStats.current?.length > 0) {
      for (let unsubscribe of unsubscribeDailyStats.current) {
        if (typeof unsubscribe === 'function') {
          unsubscribe()
        } else if (unsubscribe && typeof unsubscribe === 'object' && 'clearInterval' in unsubscribe) {
          clearInterval(unsubscribe)
        }
      }
    }
    unsubscribeDailyStats.current = []

    // Invalidate every in-flight daily-stats fetch from the PREVIOUS subscribe,
    // in both read modes, before any new one is issued. Bumped here rather than
    // inside the Supabase branch so a Supabase→Firestore flip also invalidates.
    const generation = (dailyStatsGeneration.current += 1)

    if (useSupabase) {
      // Fetch daily stats from the API (daily_stats view is the source of truth)
      const isCurrent = () => generation === dailyStatsGeneration.current

      /**
       * @returns {Promise<boolean>} whether the daily stats were actually
       * re-read. The freshness net keeps polling on `false`, so this must
       * report failure honestly rather than resolve regardless — reporting to
       * Sentry is not the same as telling the caller.
       */
      const fetchDailyStats = async (localViewRead) => {
        try {
          // ATL-2001: each store's BUSINESS day (autoclose-aware), not the device's calendar day —
          // the same day `getDailyStatID` keys the Firestore-mode listener below by. Stores on
          // different days (timezones / cutoffs) get one single-day request per day, and a row is
          // kept only for the store whose today it is. See global/Supabase/dailyStatsBusinessDays.ts.
          // The passed stores win (the atom may not have propagated yet on first load); the atom,
          // read at call time, fills in for a closure whose `storesDict` is stale.
          const storeRecords = { ...(getDefaultStore().get(storesDictAtom) || {}) }
          Object.entries(storesForLookup || {}).forEach(([key, s]) => {
            storeRecords[s?.firestoreId || key] = s
          })
          // A response row keyed by the Supabase UUID (a store with no `firestore_id`) resolves to
          // the same key `dailyStats` uses — the ATL-1118 compatibility path below.
          const storeKeyOf = (responseStoreKey) => {
            const store = Object.values(storesForLookup || {}).find(s => s?.supabaseId === responseStoreKey)
            return store?.firestoreId || responseStoreKey
          }
          const plan = planDailyStatsBusinessDays(storeRecords, Object.keys(storeIdsDict || {}), new Date())
          const todayStats = await readTodayDailyStats(plan, storeKeyOf, (date) =>
            fetchDailyStatsFromSupabase(user.organizationId, null, date, date)
          )

          // Update daily stats atom.
          //
          // ATL-1118: `/reports/daily-stats` now returns the FIRESTORE store id in both `storeId`
          // and the legacy `store` alias, so the response already arrives in `dailyStats`' key
          // space — the same one `user.store.id`, `storesForLookup` and every `dailyStats[store]`
          // reader use. It used to carry the Supabase UUID, which is why `storeKeyOf` remaps by
          // `supabaseId`; the lookup is kept only as a compatibility path for a response that
          // still carries a UUID (a store with no `firestore_id`, which the backend falls back
          // to), and it resolves to the same key either way. Do NOT reintroduce a UUID-only
          // assumption here: with a Firestore-keyed response the `find` never matches, and
          // a key rewritten on that assumption would land the stats under an id no screen reads.
          // ATL-1445 stage 3 P6: the daily stats (today's totals AND `shiftOpened`/`shiftClosed`, which
          // `/reports/daily-stats` carries) are written together with the local view's retirement of
          // what this read confirms — one update (`commitLocalViewRead`). Exactly the loop below for
          // every session today. A superseded read retires nothing (it writes nothing either).
          const writeDailyStats = () => todayStats.forEach(({ storeKey, dateKey, stat }) => {
            // Superseded by a later subscribe (day rollover / read-mode flip):
            // writing here would clobber the current day with a stale one.
            if (!isCurrent()) return
            setDailyStats((prev) => ({
              ...prev,
              [storeKey]: {
                ...stat,
                id: dateKey,
                lastFetchDate: new Date(),
                hasPendingWrites: false,
              }
            }))
          })

          commitLocalViewReadIfCurrent(localViewRead, isCurrent, writeDailyStats)

          // ATL-652: the daily_stats view only has flat org/store/day totals, so the
          // Shift/Смена screen (which reads dynamic per-wallet / per-payment-method keys)
          // rendered all zeros. Fetch the shift report and merge its flat keys into the
          // per-store dailyStats entry so ShiftScreen works unchanged. Best-effort: a
          // failure here must not break the daily-stats home/reports path.
          //
          // ATL-1338: skipped for a role that cannot reach ShiftScreen — `/reports/shift` needs
          // `Shift`, and daily-stats now also admits roles without it. Read from the store at call
          // time, not the render-time `userRole`: this closure outlives many renders.
          try {
            // ATL-2001: the same per-store business days as the daily stats above.
            const shiftStats = !shouldFetchShiftReport(getDefaultStore().get(userRoleAtom)) ? [] : await readTodayShiftStats(
              plan,
              storeKeyOf,
              (date) => fetchShiftReportFromSupabase(user.organizationId, null, date, date)
            )
            shiftStats.forEach(({ storeKey, stats }) => {
              if (!isCurrent()) return
              setDailyStats((prev) => ({
                ...prev,
                [storeKey]: {
                  ...(prev[storeKey] || {}),
                  ...stats,
                }
              }))
            })
          } catch (shiftError) {
            console.error('Error merging shift report into daily stats:', shiftError)
            Sentry.captureException(shiftError, {
              tags: { supabase_shift_report_error: true },
            })
          }
          return isCurrent()
        } catch (error) {
          console.error('Error fetching daily stats from Supabase:', error)
          Sentry.captureException(error, {
            tags: { supabase_daily_stats_error: true },
          })
          return false
        } finally {
          // ATL-1445 stage 3 P6: a read that wrote nothing (failed, superseded) settles its generation.
          if (localViewRead) abandonLocalViewRead(localViewRead)
        }
      }

      // ATL-1165: `postgres_changes` is an event STREAM, not a state sync — it
      // replays nothing on rejoin and delivers nothing while the channel is
      // down. Realtime alone therefore cannot keep the Today card correct, and
      // when it failed for Сыра market on 2026-09-03 the card sat frozen at its
      // mount-time totals through 37 minutes of live trading (Sentry
      // outageDurationMs 2_243_001) with no error shown to anyone.
      // `createDailyStatsFreshness` owns the invariant instead: it starts
      // polling and is silenced only by a channel that has actually reached
      // SUBSCRIBED, so a healthy session costs nothing and a broken one still
      // converges. See global/Supabase/dailyStatsFreshness.ts.
      const freshness = createDailyStatsFreshness({
        refetch: fetchDailyStats,
        beginRead: () => beginLocalViewRefetch('dailyStats'),
      })
      unsubscribeDailyStats.current.push(() => freshness.stop())
      // The foreground resync goes THROUGH the freshness instance rather than
      // calling `fetchDailyStats` directly: `onForeground()` absorbs a pending
      // debounced refetch, so foregrounding mid-burst issues one fetch instead
      // of one now and an identical one 500ms later. It is also the only path
      // by which a stopped instance stays inert after teardown.
      refetchDailyStats.current = () => freshness.onForeground()
      // ATL-1445 stage 3 P6: an acknowledged outbox v2 entry asks for a daily-stats read, so its totals
      // overlay is confirmed by a read that started after the ack. Never called for a session today.
      unsubscribeDailyStats.current.push(registerLocalViewReadRequester('dailyStats', () => freshness.onRealtimeChange()))

      // The initial read goes through the instance too. Issued directly (as it
      // was) it ran before the instance existed, so it sat outside the
      // single-flight guard AND carried the same generation as every other
      // read — on a busy till it could land after a change-driven read and
      // replace correct totals with pre-sale ones.
      freshness.resync()

      // Subscribe to daily_stats_changes table via Supabase Realtime
      // Triggers on source tables (sales, spendings, etc.) UPSERT into this table,
      // and we get notified here instead of polling every 30s
      const supabaseOrgId = subscriptionContextRef.current?.supabaseOrgId
      if (supabaseOrgId) {
        const channel = createRealtimeChannel(
          `daily_stats_changes:${supabaseOrgId}`,
          'daily_stats_changes',
          supabaseOrgId,
          () => freshness.onRealtimeChange(),
          { onStateChange: (state, gap) => freshness.onRealtimeState(state, gap) }
        )

        if (channel) {
          unsubscribeDailyStats.current.push(() => unsubscribeChannel(channel))
        }
      } else {
        // No supabaseOrgId yet, so no channel is opened at all. The freshness
        // poll above is already armed and is the fallback — it is never
        // disarmed here, because nothing can report SUBSCRIBED.
        console.warn('⚠️ No supabaseOrgId for daily stats subscription, falling back to polling')
      }
    } else {
      // Use Firestore real-time listeners. No freshness net: `onSnapshot`
      // re-delivers the current document whenever the listener reconnects, so
      // the ATL-1165 gap does not exist on this path.
      refetchDailyStats.current = null
      for (let storeId in storeIdsDict) {
        let unsubscribeDailyStat = db.collection('dailyStats').doc(getDailyStatID(storeId, new Date())).onSnapshot({
          includeMetadataChanges: true
        }, function(doc) {
          if (snapshotExists(doc)) {
            var statDoc = doc.data()
            statDoc.id = doc.id
            statDoc.ref = doc.ref
            statDoc.lastFetchDate = new Date()
            statDoc.hasPendingWrites = doc.metadata.hasPendingWrites
            setDailyStats((dailyStats) => ({
              ...dailyStats, [statDoc.store]: statDoc
            }))
          }
        })
        unsubscribeDailyStats.current.push(unsubscribeDailyStat)
      }
    }
    // The business day (autoclose-aware), matching the key space of everything subscribed above
    // and of the snapshot written below — see the AppState handler for why the calendar day is the
    // wrong basis here.
    today.current = getStoreBusinessDate()
    // ATL-1445 stage 3 P6: the local view's "today" for a store the server has no entry for yet
    // (a shift opened offline before the day's first row). A no-op with no pending writes.
    refreshLocalViewDay()
    // ATL-1123: today's product stock snapshot — the P&L's opening/closing stock lines read it back
    // from `productStockSnapshots`. This call was deleted as collateral of the daily-stats Supabase
    // refactor in 896466fd (2026-01-12) and shipped in v6.9.0 on 2026-06-05, which is the day
    // production stopped writing snapshots fleet-wide. It belongs HERE, on the same rollover path
    // that resubscribes the stats, so the snapshot is taken once per business day per store in both
    // read modes; the function itself is idempotent and refuses a catalogue it cannot stand behind.
    // `subscribeToDailyStats` is synchronous, so nothing awaits this: a throw from OUTSIDE the
    // writer's per-store try (a jotai read, or `getDailyStatID` on an unparseable date) would
    // otherwise surface only as an unhandled rejection, which is exactly the silence that let the
    // missing call site go unnoticed for three months.
    saveProductStockSnapshot().catch(error => {
      Sentry.captureException(error, { tags: { feature: 'productStockSnapshot', books_write_error: 'product-stock-snapshot-save' } })
    })
  }

  const setUserInfoToAnalytics = (user, org) => {
    if (runOnceRef.current) return
    Sentry.setUser({organizationId: user.organizationId, organizationName: org.name, id: user.uid, username: user.name, email: user.email })
    setFBAnalyticsUserId(user.uid)
    setFBAnalyticsUserProperties({organizationId: user.organizationId, organizationName: org.name, id: user.uid, username: user.name, email: user.email })
    
    // Set PostHog user
    postHog.identify(user.uid, {
      email: user.email,
      name: user.name,
      organizationId: user.organizationId,
      organizationName: org.name,
      role: user.role
    })
    // ATL-531: dual_write_eligible is org-dependent, so it registers here at identify (the org
    // atom is committed synchronously one line before both call sites). The STATIC build
    // provenance (update_id, js_version, …) registers app-wide at PostHogProvider mount in
    // Routes.js so even pre-login / post-OTA-reload events carry the current bundle's identity.
    // shouldDualWrite() reads Remote Config, which activates asynchronously at boot — at identify
    // time it may still be '' (prod fails CLOSED), making this a false negative. Re-register once
    // RC settles, with rc_status (fetched/cache/error) so analysts can tell a real gate decision
    // from an RC fetch failure (ATL-531/533).
    //
    // ATL-786: the two registers MUST be sequenced. As two independent `void` calls, the
    // pre-settle snapshot ({eligible:false}, no rc_status) could land AFTER the settled one and
    // stamp the whole session eligible=false with a LEFTOVER rc_status persisted from an earlier
    // session — exactly the (false, 'fetched') contradiction observed live. rc_status:'pending'
    // also stops the pre-settle stamp from borrowing a stale status. The raw allowlist rides
    // along so a deny is diagnosable from the event itself (stale cohort vs current policy).
    void postHog
      .register({ dual_write_eligible: shouldDualWrite(), rc_status: 'pending' })
      .then(() => remoteConfigReady)
      .then(rcStatus => postHog.register({ dual_write_eligible: shouldDualWrite(), rc_status: rcStatus, dual_write_allowlist_raw: allowlistRawForTelemetry() }))
      .catch(() => {})
    // ATL-901: every field is optional and this cannot throw — see utils/organizationAnalytics.js.
    // `currency: org.currency.id` here was an uncaught TypeError inside a Firestore onSnapshot
    // callback for any org whose document lacks a currency, which killed the app at launch.
    postHog.group('organization', user.organizationId, buildOrganizationAnalyticsGroup(org))
    // for billing update limits
    if (user?.role === 'admin') { 
      let startDate = new Date()
      startDate.setDate(1)
      startDate.setHours(0,0,0,0)
      let newRange = dateRangeWithTimezoneAndAutoclose({startDate: startDate, endDate: new Date()})
      getStatsForDays(db, newRange).then((values) => {
        let sum = 0
        for (let value of values) {
          sum += (value.saleAmount || 0)
        }
        // ATL-901: the SECOND unguarded dereference of the same field, and the one that hit the
        // admin 35 times. `CURRENCIES.find(e => e.id === undefined)` returns undefined, so
        // `.exchangeRate` threw — inside a .then(), i.e. an unhandled rejection with no console
        // message, which is why it produced no usable diagnostic. A missing currency now skips the
        // USD figure (an analytics nicety) instead of taking the session down; lastActive, which
        // actually matters, is still written below.
        const currency = resolveOrganizationCurrency(org, CURRENCIES)
        if (!currency) {
          console.warn('[billing] organization has no resolvable currency; skipping currentMonthSalesUSD', {
            organizationId: user.organizationId,
            currency: org?.currency,
          })
          rootDb.collection('organizations').doc(user.organizationId).update({ lastActive: new Date() })
          return
        }
        // ATL-615: this Firestore write feeds the gate in Firestore READ mode. In Supabase read
        // mode currentMonthSalesUSD is computed server-side from sales (get_org_current_month_sales_usd),
        // so it is NOT dual-written here — no stale/missing value at the Phase-5 cutover.
        rootDb.collection('organizations').doc(user.organizationId).update({
          currentMonthSalesUSD: sum/currency.exchangeRate,
          currentMonthSalesUSDLastUpdated: new Date(),
          lastActive: new Date()
        })
      })
    }  else {
      rootDb.collection('organizations').doc(user.organizationId).update({lastActive: new Date()})
    }
    runOnceRef.current = true
  }

  // ATL-1405 — `getInitialData` runs on EVERY `[db, user]` change, not once per session, and it
  // used to overwrite `unsubscribeOthers.current` without calling what was in it. Each re-run
  // therefore leaked the previous run's listeners, and in Supabase mode it re-opened all 23
  // realtime channels under the SAME names while the old ones were still joined — which realtime-js
  // resolves by handing back the old channel and stacking a second binding on it. The next socket
  // reconnect then rejected every one of them ("mismatch between server and client bindings for
  // postgres changes") and they never came back. Tear the previous run down before starting.
  const teardownInitialDataSubscriptions = () => {
    const unsubscribes = unsubscribeOthers.current || []
    unsubscribeOthers.current = []
    for (const unsubscribe of unsubscribes) {
      unsubscribe()
    }
    // Stops the previous context's in-flight refetches from writing over this run's data. The ref
    // itself is left in place until the new context replaces it: the daily-stats subscription
    // reads the organization UUID from it.
    if (subscriptionContextRef.current) {
      cleanupPendingRefetches(subscriptionContextRef.current)
    }
  }

  const getInitialData = async () => {
    let otherUnsubscribes = []
    let supabaseChannels = []

    const run = (initialDataRun.current += 1)
    // A newer run started while this one was awaiting: it owns the subscriptions now, and this one
    // must neither open its own nor write its (older) reads over the newer run's.
    //
    // The previous run's subscriptions are torn down only once THIS run is about to install its
    // own (`teardownInitialDataSubscriptions` below, in each branch) — not here. A run that fails
    // before that point (no auth token while offline, a failed initial load) would otherwise leave
    // the till with no live subscriptions at all until the next `[db, user]` change.
    const superseded = () => run !== initialDataRun.current

    // Wait for auth.currentUser AND a valid token to be available (race condition fix)
    // The user atom can be set before Firebase's auth.currentUser is populated
    // and getIdToken() might return stale/invalid token right after login
    const waitForValidAuthToken = async (maxWaitMs = 5000) => {
      const startTime = Date.now()
      while (Date.now() - startTime < maxWaitMs) {
        if (auth.currentUser) {
          try {
            // Force refresh to ensure we get a valid token
            const token = await auth.currentUser.getIdToken(true)
            if (token) {
              return { user: auth.currentUser, token }
            }
          } catch (e) {
            // Token not ready yet, keep waiting
          }
        }
        await new Promise(resolve => setTimeout(resolve, 100))
      }
      return null
    }

    // ATL-886: resolve the per-org read-cutover flag BEFORE choosing a data source.
    //
    // `shouldUseSupabase()` reads `organization.useSupabaseForData` out of `organizationAtom`,
    // which is a plain in-memory atom and is `{}` on every cold start. The organization document
    // carrying that flag used to be loaded only inside the `if (!useSupabase)` branch below —
    // AFTER this decision — so the flag was always read one step too early and the per-org cutover
    // could never take effect for any org. Priming it here is the whole fix; the ordering is
    // asserted by orgReadCutoverOrdering.test.js because types cannot enforce it.
    //
    // Resolves towards Firestore on any failure. See orgReadCutover.ts for why this is a fresh
    // read rather than an AsyncStorage cache like the device override.
    //
    // ATL-1445 stage 3 (P4): the WRITE flag is remembered, unlike the read flag (an unreadable write
    // flag keeps a remembered 'supabase' — global/Write/writeMode.ts). The memory is read in
    // parallel with the document so it costs no extra latency; it never rejects.
    const lastKnownWritesMasterRead = writesMasterMemory.recall(user.organizationId)
    const readCutover = await primeOrganizationForReadCutover({
      organizationId: user.organizationId,
      fetchOrganizationDoc: (organizationId) =>
        rootDb.collection('organizations').doc(organizationId).get(),
      setOrganization,
    })
    // Before recording the source decision: a superseded run must not overwrite the newer run's.
    if (superseded()) return

    // Check device setting for backend choice
    const useSupabase = shouldUseSupabase()
    // ATL-888: record the decision at the point it is made, so the live-rollback watch knows what
    // this session is actually doing. Must stay adjacent to the branch above — see
    // orgReadCutoverOrdering.test.js.
    sessionReadsSupabaseRef.current = useSupabase
    // A flag change observed during startup was retained rather than discarded; decide it now that
    // there is something to compare it against.
    readCutoverWatchRef.current?.reevaluate()

    // ATL-2052: once per launch, whether this till persists ATL-1459 mirror intents for its
    // organization, and why — so a canary is certified by tills that report themselves ON. Not
    // awaited (it waits for the boot Remote Config fetch); it never rejects.
    void reportMirrorIntentSession({ organizationId: user.organizationId, readsSupabase: useSupabase })

    // ATL-1445 stage 3 (P4): pin this session's WRITE mode from the same organization-document read as
    // the read pin (stage-3 §4), once the device's memory of the flag has loaded. NOT awaited: the
    // first data load must not wait on storage. Until the pin lands an incapable bundle is in
    // Firestore mode (writeW.ts), which is what its writers do anyway; a capable bundle and a staging
    // cut-over preview build refuse W writes until then (ATL-1678). Pinned once, never re-read per
    // call (ATL-888); a later run for the same organization keeps the pin and reports any divergence.
    //
    // P5: the pin must not lower this session to Firestore mode while outbox v2 still holds this
    // organization's master writes. Startup looks at the queue only when it CAN hold any
    // (`decideStartupOutboxLook`: 'none' for every organization today, so this path is P4's exactly —
    // no store opened, the pin taken in this same callback). After the pin, the watcher re-decides
    // its write plane, which it defers until there is a pin to compare with.
    lastKnownWritesMasterRead
      .then((lastKnownWritesMaster) => {
        // A newer run owns the session; its pin is the one that counts.
        if (superseded()) return
        const pinWriteMode = (outboxV2) => {
          if (superseded()) return
          reportSessionWriteMode(
            pinSessionWriteModeAtStartup({
              organizationId: user.organizationId,
              observation: readCutover.writesMaster,
              lastKnown: lastKnownWritesMaster,
              sessionReadsSupabase: useSupabase,
              outboxV2,
            })
          )
          startSessionOutboxAfterPin(user.organizationId, outboxV2, {
            onMasterRecheck: () => readCutoverWatchRef.current?.reevaluateWritePlane(),
            register: (properties) => postHog?.register?.(properties),
          })
          readCutoverWatchRef.current?.reevaluateWritePlane()
        }
        const outboxLook = decideStartupOutboxLook(readCutover.writesMaster, lastKnownWritesMaster, WRITE_W_CAPABILITY)
        // ATL-1445 stage 3 P6: a session whose outbox v2 can hold entries holds its first catalogue write
        // until the local view is rebuilt (bounded). Never for a session today ('none').
        if (outboxLook !== 'none') openLocalViewStartupBarrier(user.organizationId)
        if (outboxLook === 'before-pin') return probeOutboxV2Presence(user.organizationId).then((probe) => pinWriteMode(probe.presence))
        pinWriteMode('not-checked')
        // Review 1: a Supabase-master organization's session (refuse included) looks at v2 AFTER its pin
        // and drains what it holds (or pages when it cannot read it). Never for an organization today.
        if (outboxLook === 'after-pin') {
          return probeOutboxV2Presence(user.organizationId).then((probe) => {
            if (superseded()) return
            startSessionOutboxAfterPin(user.organizationId, probe.presence, {
              onMasterRecheck: () => readCutoverWatchRef.current?.reevaluateWritePlane(),
              register: (properties) => postHog?.register?.(properties),
            })
          })
        }
      })
      .catch((error) => console.error('[write-mode] pinning the session write mode failed', error))
    // The read-cutover status is printed alongside the choice on purpose: this is the line a human
    // actually reads, and "Firestore" alone cannot distinguish "this org is not cut over" from
    // "the flag could not be resolved" — a distinction that cost a day of false confidence.
    console.log(
      `📊 Loading data from ${useSupabase ? 'Supabase' : 'Firestore'} (read-cutover: ${readCutover.status})`
    )

    // ATL-886 regression canary. With the flag resolved above, an org that asks for Supabase can
    // only end up on Firestore if that resolution has regressed — which is precisely the failure
    // that went unnoticed from the first read-cutover attempt (2026-08-06) until a human opened
    // the app and read the log line above. Every automated check at the time passed, because they
    // all read the Supabase column rather than what the client actually did.
    if (getOrganization()?.useSupabaseForData === true && !useSupabase) {
      console.error(
        '📊 [read-cutover] ORG IS CUT OVER BUT THIS SESSION CHOSE FIRESTORE — the ATL-886 ' +
          'bootstrap-ordering defect has regressed',
        { organizationId: user.organizationId, readCutoverStatus: readCutover.status }
      )
    }

    // For Supabase, we need auth token; for Firestore, we can proceed without it
    if (useSupabase) {
      const authResult = await waitForValidAuthToken()
      if (!authResult) {
        // A newer run owns the session now; its own outcome is the one the merchant should see.
        if (superseded()) return
        console.error('auth.currentUser or valid token not available after waiting, cannot fetch data')
        toast.show('Ошибка авторизации. Пожалуйста, перезайдите в приложение.', {
          type: 'danger',
          duration: 10000,
        })
        return
      }
      // Small delay to ensure token cache is propagated
      await new Promise(resolve => setTimeout(resolve, 200))
    }
    if (superseded()) return

    // FIRESTORE PATH
    if (!useSupabase) {
      teardownInitialDataSubscriptions()
      // Load data from Firestore using real-time listeners
      let unsubscribeConstants = db.collection('constants').onSnapshot(function(querySnapshot) {
        var docs = {}
        querySnapshot.forEach(function(doc) {
          var snap = doc.data()
          snap.id = doc.id
          snap.ref = doc.ref
          docs[snap.id] = snap
        })
        var roles = {}
        docs.roles?.data?.forEach(element => {
          roles[element.id] = element
        })
        setRoles(roles)
        var productUnits = {}
        docs.productUnits?.data?.forEach(element => {
          productUnits[element.id] = {...element, text: element.name}
        })
        setProductUnitsDict(productUnits)
        setConstants(docs)
        if (docs.discountOptions?.data) {
          let newOptions = [
            { title: t('newSale.withoutDiscount'), text: t('newSale.withoutDiscount'), percentage: 0 },
            { title: t('newSale.discountAmount'), text: t('newSale.discountAmount'), amount: 0 }
          ]
          for (let option of docs.discountOptions.data) {
            let newOption = {
              title: option.text + '%',
              text: option.text + '%',
              percentage: parseFloat(option.text)
            }
            newOptions.push(newOption)
          }
          setDiscountOptionsList(newOptions)
        }
      })
      otherUnsubscribes.push(unsubscribeConstants)

      subscribeToDailyStats({[user.store.id]: {}}, null, false)

      let unsubscribeOrganization = rootDb.collection('organizations').doc(user.organizationId).onSnapshot(function(querySnapshot) {
        let doc = querySnapshot.data()
        if (doc != null) {
          doc.id = querySnapshot.id
          doc.ref = querySnapshot.ref
          setOrganization(doc)
          // ATL-901: defence in depth. A throw inside this snapshot callback is UNCAUGHT — React
          // Native treats it as a fatal and kills the app — so on 2026-08-13 one malformed org
          // document locked a paying customer out of iOS, Android AND the web fallback for four
          // hours, with no route to in-app support. The specific field is fixed in
          // utils/organizationAnalytics.js; this catch is the guarantee that the NEXT unexpected
          // shape degrades telemetry instead of the till. Reported, never swallowed silently.
          try {
            setUserInfoToAnalytics(user, doc)
          } catch (error) {
            console.error('[analytics] setUserInfoToAnalytics failed; app continues', error)
            Sentry.captureException(error)
          }
        } else {
          setOrganization(null)
        }
      })
      otherUnsubscribes.push(unsubscribeOrganization)

      let unsubscribeProductCategories = db.collection('productCategories').orderBy('order').onSnapshot(function(querySnapshot) {
        let docs = []
        let dict = {}
        querySnapshot.forEach(function(doc) {
          let productCategory = doc.data()
          productCategory.text = productCategory.name
          productCategory.title = productCategory.name
          productCategory.id = doc.id
          productCategory.ref = doc.ref
          docs.push(productCategory)
          dict[productCategory.id] = productCategory
        })
        setProductCategories(dict)
      })
      otherUnsubscribes.push(unsubscribeProductCategories)

      let unsubscribeUsers = rootDb.collection('users').where('organizationId', '==', user.organizationId).onSnapshot(function(querySnapshot) {
        let dict = {}
        let inactiveUsers = {}
        querySnapshot.forEach(function(doc) {
          let fetchedUser = doc.data()
          fetchedUser.id = doc.id
          fetchedUser.ref = doc.ref
          fetchedUser.text = fetchedUser.name
          fetchedUser.title = fetchedUser.name
          if (fetchedUser.active) {
            dict[fetchedUser.id] = fetchedUser
          } else {
            inactiveUsers[fetchedUser.id] = fetchedUser
          }
        })
        setUsersDict(dict)
        setInactiveUsers(inactiveUsers)
      })
      otherUnsubscribes.push(unsubscribeUsers)

      let unsubscribeStores = db.collection('stores').onSnapshot(function(querySnapshot) {
        let docs = {}
        querySnapshot.forEach(function(doc) {
          let snap = doc.data()
          snap.id = doc.id
          snap.ref = doc.ref
          snap.text = snap.name
          snap.localDate = getLocalStoreDate(snap.id)
          docs[snap.id] = snap
        })
        setStores(docs)
        if (Object.values(docs).length > 1) {
          subscribeToDailyStats(docs, null, false)
        }
      })
      otherUnsubscribes.push(unsubscribeStores)

      let unsubscribeProducts = db.collection('products').orderBy('name').onSnapshot(function(querySnapshot) {
        let allFlatDocsDict = {}
        querySnapshot.forEach(function(doc) {
          let product = doc.data()
          product.id = doc.id
          product.ref = doc.ref
          allFlatDocsDict[product.id] = product
        })
        setProductsDict(allFlatDocsDict)
        setProductsUpdated((prev) => ({...prev, updateCount: prev.updateCount + 1}))
      })
      otherUnsubscribes.push(unsubscribeProducts)

      let unsubscribeSuppliers = db.collection('suppliers').orderBy('name').onSnapshot(function(querySnapshot) {
        let docs = []
        let dict = {}
        querySnapshot.forEach(function(doc) {
          let supplier = doc.data()
          supplier.text = supplier.name
          supplier.title = supplier.name
          supplier.id = doc.id
          supplier.ref = doc.ref
          docs.push(supplier)
          dict[supplier.id] = supplier
        });
        setSuppliersDict(dict)
      })
      otherUnsubscribes.push(unsubscribeSuppliers)

      // Print templates are dual-written to the org-scoped `printTemplates` collection. The
      // Supabase path hydrates printTemplatesAtom in `loadInitialSupabaseData` above and refreshes
      // it from the `print_templates` subscription; mirror it here so PrintSettings isn't empty in
      // Firestore-read mode (ATL-463).
      //
      // This comment used to claim the Supabase path hydrated the atom "via the subscription
      // factory". It did not — that subscription was `clearOnly`, so it could only ever set `[]`,
      // and nothing else fetched. Documenting a coupling is not checking that anything honours it.
      let unsubscribePrintTemplates = db.collection('printTemplates').onSnapshot(function(querySnapshot) {
        let docs = []
        querySnapshot.forEach(function(doc) {
          let template = doc.data()
          template.id = doc.id
          // Store a plain serializable ref ({ id }), NOT the live Firestore DocumentReference.
          // printTemplatesAtom is persisted (atomWithAsyncStorage → JSON.stringify); the native
          // @react-native-firebase doc.ref is cyclical and crashes the stringify on iOS
          // (TypeError: cyclical structure in JSON object). Matches the Supabase path's ref shape;
          // consumers resolve a live ref via getFirestoreRef(ref, 'printTemplates') when needed.
          template.ref = { id: doc.id }
          docs.push(template)
        })
        setPrintTemplates(docs)
      })
      otherUnsubscribes.push(unsubscribePrintTemplates)

      unsubscribeOthers.current = otherUnsubscribes
      console.log('✅ Firestore data loaded successfully')
      return
    }

    // SUPABASE PATH - Load all data from Supabase
    {
      // ATL-1445 stage 3 P6: this load is a read of the products surface (local view generation); it is
      // written through `commitLocalViewRead` below, or settled by the `finally` if it never is.
      const productsRead = beginLocalViewRefetch('products')
      try {
        // ATL-970: `loadInitialSupabaseData` is the only place that decides what a failed read
        // means. It keeps "this organization has nothing" and "we could not find out" apart —
        // the old code could not, because every fetcher swallowed its error and returned `{}`,
        // so a failed products fetch produced an empty till and the log line below.
        const { data, degraded } = await loadInitialSupabaseData({
          fetchers: {
            products: () => fetchProductsFromSupabase(user.organizationId, user.store?.id),
            productCategories: () => fetchProductCategoriesFromSupabase(user.organizationId),
            stores: () => fetchStoresFromSupabase(user.organizationId),
            users: () => fetchUsersFromSupabase(user.organizationId),
            suppliers: () => fetchSuppliersFromSupabase(user.organizationId),
            printTemplates: () => fetchPrintTemplatesFromSupabase(user.organizationId),
            constants: () => fetchConstantsFromSupabase(user.organizationId),
            organization: () => fetchOrganizationFromSupabase(user.organizationId),
          },
        })

        if (superseded()) return
        // ATL-1445 stage 3 P6: a session whose outbox v2 holds entries rebuilds its local view from
        // them before the catalogue is first shown (bounded, `LOCAL_VIEW_REBUILD_TIMEOUT_MS`). `null` —
        // no await at all — for every session whose v2 cannot hold anything, i.e. every session today.
        // Here, before the synchronous section below, so that section stays synchronous.
        const localViewRebuild = localViewStartupBarrier(user.organizationId)
        if (localViewRebuild) {
          await localViewRebuild
          if (superseded()) return
        }
        // Everything from here to the subscriptions below is synchronous, so the previous run's
        // listeners and in-flight refetches stop before any of this run's data is written.
        teardownInitialDataSubscriptions()

        const { products, productCategories: categories, stores, constants, organization: supabaseOrg } = data

        if (degraded.length > 0) {
          // Not fatal, but never silent: these atoms keep their previous contents, so the merchant
          // is looking at data that may be stale and has no other way to know.
          Sentry.captureException(new Error('Supabase initial load degraded'), {
            tags: { supabase_initial_load_degraded: true },
            extra: {
              organizationId: user.organizationId,
              collections: degraded.map((d) => d.collection).join(','),
            },
          })
          toast.show(
            t('dataLoad.partial', {
              collections: degraded
                .map((d) => t(`dataLoad.collections.${d.collection}`, { defaultValue: d.collection }))
                .join(', '),
            }),
            { type: 'warning', duration: 8000 }
          )
        }

        setOrganization(supabaseOrg)
        setUserInfoToAnalytics(user, supabaseOrg)

        // Update atoms with fetched data. A collection is written ONLY if it loaded: a degraded
        // one is absent from `data`, and leaving its atom alone keeps the last known-good copy
        // rather than blanking it.
        commitLocalViewRead(productsRead, () => setProductsDict(products))
        setProductsUpdated((prev) => ({...prev, updateCount: prev.updateCount + 1}))
        setProductCategories(categories)

        // Add localDate to stores (client-side calculation based on timezone)
        Object.values(stores).forEach(store => {
          store.localDate = getLocalStoreDate(store.firestoreId || store.id)
        })
        setStores(stores)
        
        // Process users (active/inactive). Absent means the fetch failed and was ruled
        // non-critical, so the atoms keep whatever they last held.
        if (data.users) {
          const activeUsers = {}
          const inactiveUsersList = {}
          Object.values(data.users).forEach(fetchedUser => {
            if (fetchedUser.active) {
              activeUsers[fetchedUser.id] = fetchedUser
            } else {
              inactiveUsersList[fetchedUser.id] = fetchedUser
            }
          })
          setUsersDict(activeUsers)
          setInactiveUsers(inactiveUsersList)
        }

        if (data.suppliers) {
          setSuppliersDict(data.suppliers)
        }

        // Print templates. Absent means the fetch failed and was ruled non-critical, so the atom
        // keeps whatever it last held (it is persisted) rather than being blanked — blanking is
        // what silently drops the merchant's invoice layout back to the built-in one.
        if (data.printTemplates) {
          setPrintTemplates(data.printTemplates)
        }

        // Process constants. `constants` is critical, so reaching here means it loaded — the old
        // `else` branch that fabricated a role when it had "failed to load" was unreachable state
        // dressed as a fallback, and it is exactly what let a failed load look like a working one.
        {
          setConstants(constants)

          // Process roles - key by firestoreId for migrated data compatibility
          const roles = {}
          constants.roles?.data?.forEach(element => {
            // Use firestoreId as key since users.role contains firestoreId, not UUID
            // Note: transformRole returns camelCase firestoreId, not snake_case firestore_id
            const roleKey = element.firestoreId || element.firestore_id || element.id
            // Normalize the role object: set id to firestoreId so existing admin checks work
            // (many places check userRole?.id === 'admin')
            roles[roleKey] = {
              ...element,
              id: element.firestoreId || element.firestore_id || element.id, // Use firestoreId as id for compatibility
              uuid: element.id, // Keep the actual UUID as uuid if needed
            }
          })

          // Ensure user's role exists in roles dict, create fallback if needed
          if (user?.role && !roles[user.role]) {
            console.warn(`User role "${user.role}" not found in constants.roles, creating fallback role`)
            roles[user.role] = {
              id: user.role,
              name: user.role,
              permissions: {} // Must be an object, not array, for permission lookups
            }
          }
          
          setRoles(roles)
          
          // Process product units - use firestoreId as key for compatibility with product.productUnit
          const productUnits = {}
          constants.productUnits?.data?.forEach(element => {
            // Use firestoreId as key since products store base_unit as the Firestore ID (e.g., "piece")
            const key = element.firestoreId || element.id
            productUnits[key] = element
          })
          setProductUnitsDict(productUnits)

          // Process discount options
          if (constants.discountOptions?.data) {
            let newOptions = [
              { title: t('newSale.withoutDiscount'), text: t('newSale.withoutDiscount'), percentage: 0 },
              { title: t('newSale.discountAmount'), text: t('newSale.discountAmount'), amount: 0 }
            ]
            for (let option of constants.discountOptions.data) {
              let newOption = {
                title: option.text + '%',
                text: option.text + '%',
                percentage: parseFloat(option.text)
              }
              newOptions.push(newOption)
            }
            setDiscountOptionsList(newOptions)
          }
        }

        // Set up real-time subscriptions
        // Use Supabase UUID for table filters (organization_id column contains UUIDs)
        // Use Firestore ID for organization subscription (filtered by firestore_id)
        if (!supabaseOrg?.supabaseId) {
          // ATL-970: this used to `return`, which left the till running with NO live updates and
          // said nothing — the same silence, one screen further along. The organization read
          // succeeded, so a missing UUID is a data problem worth surfacing, not a degradation to
          // absorb.
          throw new Error('Supabase organization has no supabaseId; realtime cannot be subscribed')
        }
        const supabaseOrgId = supabaseOrg.supabaseId // Use actual Supabase UUID, not firestoreId

        // Set up all subscriptions using declarative config
        const subscriptionContext = {
          supabaseOrgId,
          firestoreOrgId: user.organizationId,
          // Atom setters
          setConstants,
          setRoles,
          setProductCategories,
          setSuppliersDict,
          setProductsDict,
          setProductsUpdated,
          setProductUnitsDict,
          setDiscountOptionsList,
          setStores,
          setUsersDict,
          setInactiveUsers,
          setOrganization,
          setPrintTemplates,
          // Callbacks
          resubscribeDailyStats: (updatedStores) => {
            if (Object.values(updatedStores).length > 1) {
              subscribeToDailyStats(updatedStores, null, true)
            }
          },
          setUserInfoToAnalytics,
          // i18n
          t,
          // User context
          user,
          // The store the products above were loaded for — a products resync must ask for the same.
          storeId: user.store?.id,
        }

        const channels = setupAllSubscriptions(subscriptionContext)
        supabaseChannels.push(...channels)
        subscriptionContextRef.current = subscriptionContext // Store for cleanup

        // Store channels for cleanup
        unsubscribeOthers.current = [
          ...otherUnsubscribes,
          () => {
            supabaseChannels.forEach(channel => unsubscribeChannel(channel))
          }
        ]
        
        // Subscribe to daily stats (polling for views)
        // Pass stores for ID mapping since storesDict state update may not have propagated yet
        subscribeToDailyStats({[user.store.id]: {}}, stores, true)
        
        console.log('✅ Supabase data loaded successfully')
        return
      } catch (error) {
        // A superseded run's failure is not the session's: the newer run reports its own outcome,
        // and a "data failed to load" toast here would contradict a load that succeeded.
        if (superseded()) return
        console.error('Error setting up Supabase data:', error)
        Sentry.captureException(error, {
          tags: { supabase_setup_error: true },
          extra: {
            organizationId: user.organizationId,
            errorMessage: error.message,
            // ATL-970: name every collection that failed, not just the first. A single root cause
            // usually takes several down at once and reporting one hides the shape.
            failedCollections: error instanceof SupabaseInitialLoadError
              ? error.failures.map((f) => f.collection).join(',')
              : undefined,
          },
        })
        toast.show(t('dataLoad.failed'), {
          type: 'danger',
          duration: 10000,
        })
      } finally {
        // ATL-1445 stage 3 P6: settles the products read if it was never written (a no-op otherwise).
        abandonLocalViewRead(productsRead)
      }
    }
  }

  if (!userRole || versionLoading) {
    return <Spinner />
  }

  if (isBlocked) {
    return (
      <>
        <BlockedScreen config={versionConfig} />
        <FloatingButtonWithModal />
      </>
    )
  }

  // Only the paywall's two screens are mounted for an expired legacy trial — no ProductDetail route.
  const paywallOnly =
    organizationSubscriptionInfo?.pricingModel === 'trial_19_08_23' &&
    organizationSubscriptionInfo?.subscriptionStatus !== 'active'

  return (
    <>
      { paywallOnly ?
        <Stack.Navigator>
          <Stack.Screen name="Paywall" component={PaywallScreen} options={{ title: '' }} />
          <Stack.Screen name='Misc' component={MiscScreen} options={{ title: t('misc') }} />
        </Stack.Navigator> 
        : 
        <Stack.Navigator>
          <Stack.Screen name="Home" component={HomeScreen} options={{ title: '' }} />

          <Stack.Screen name="NewSale" component={NewSaleScreen} options={{ title: t('newSale.newSale') }} />
          <Stack.Screen name="AddCartItem" component={AddCartItemScreen} options={{ title: t('newSale.addCartItem') }} />
          <Stack.Screen name="EditCartItem" component={EditCartItemScreen} options={{ title: t('newSale.editCartItem') }} />
          
          <Stack.Screen name="SalesHistory" component={SalesHistoryScreen} options={{ title: t('salesHistory.salesHistory') }} />
          <Stack.Screen name="SaleDetail" component={SaleDetailScreen} options={{ title: t('salesHistory.saleDetail') }} />
          <Stack.Screen name="ReturnSale" component={ReturnSaleScreen} options={{ title: t('salesHistory.returnSale') }} />

          <Stack.Screen name="Products" component={ProductsScreen} options={{ title: t('productsAndIngredients.productsAndIngredients') }} />
          <Stack.Screen name="ProductDetail" component={ProductDetailScreen} options={{ title: t('product') }} />
          <Stack.Screen name="AddIngredientToProduct" component={AddIngredientToProductScreen} options={{ title: t('product') }} />
          <Stack.Screen name="BatchProductEdit" component={BatchProductEditScreen} options={{ title: t('batchEditProducts') }} />

          <Stack.Screen name="Revisions" component={RevisionsScreen} options={{ title: t('revisions.revisions') }} />
          <Stack.Screen name="RevisionDetail" component={RevisionDetailScreen} options={{ title: t('revisions.revision') }} />

          <Stack.Screen name="ComplexSales" component={ComplexSalesScreen} options={{ title: t('complexSales.complexSales') }} />
          <Stack.Screen name="ComplexSaleDetail" component={ComplexSaleDetailScreen} options={{ title: t('complexSales.complexSale') }} />
          <Stack.Screen name="ComplexSaleTemplates" component={ComplexSaleTemplatesScreen} options={{ title: t('complexSales.templates') }} />

          <Stack.Screen name='Supplies' component={SuppliesScreen} options={{ title: t('supplies.supplies') }} />
          <Stack.Screen name='SupplyDetail' component={SupplyDetailScreen} options={{ title: t('supplies.supply') }} />

          <Stack.Screen name='WriteOffs' component={WriteOffsScreen} options={{ title: t('writeOffs.writeOffs') }} />
          <Stack.Screen name='WriteOffDetail' component={WriteOffDetailScreen} options={{ title: t('writeOffs.writeOff') }} />

          <Stack.Screen name='Manufactures' component={ManufacturesScreen} options={{ title: t('manufactures.manufactures') }} />
          <Stack.Screen name='ManufactureDetail' component={ManufactureDetailScreen} options={{ title: t('manufactures.manufacture') }} />

          <Stack.Screen name='Spendings' component={SpendingsScreen} options={{ title: t('spendings.spendings') }} />
          <Stack.Screen name='SpendingDetail' component={SpendingDetailScreen} options={{ title: t('spendings.spending') }} />
          <Stack.Screen name='RecurringSpendingDetail' component={RecurringSpendingDetailScreen} options={{ title: t('spendings.monthlySpendings') }} />
          
          <Stack.Screen name='ProductStocks' component={ProductStocksScreen} options={{ title: t('productStocks.productStocks') }} />
          <Stack.Screen name="ProductStockMovement" component={ProductStockMovementScreen} options={{ title: t('productStocks.productStockMovementHistory') }} />

          <Stack.Screen name='Shift' component={ShiftScreen} options={{ title: t('shift.shift') }} />
          <Stack.Screen name='CashboxTransaction' component={CashboxTransactionScreen} options={{ title: t('shift.shift') }} />

          <Stack.Screen name='Transfers' component={TransfersScreen} options={{ title: t('transfers.transfers') }} />
          <Stack.Screen name='TransferDetail' component={TransferDetailScreen} options={{ title: t('transfers.transfer') }} />
          
          <Stack.Screen name='ClientOrders' component={ClientOrdersScreen} options={{ title: t('clientOrders.clientOrders') }} />
          <Stack.Screen name='ClientOrderDetail' component={ClientOrderDetailScreen} options={{ title: t('clientOrders.clientOrder') }} />

          <Stack.Screen name='PaymentStats' component={PaymentStatsScreen} options={{ title: t('payments.paymentStats') }} />
          <Stack.Screen name='PaymentTransactions' component={PaymentTransactionsScreen} options={{ title: t('payments.paymentTransactions') }} />
          <Stack.Screen name='PaymentTransactionDetail' component={PaymentTransactionDetailScreen} options={{ title: t('payments.paymentTransaction') }} />

          <Stack.Screen name='PrintStickers' component={PrintStickersScreen} options={{ title: t('printStickers.printStickers') }} />
          <Stack.Screen name='AddProductSticker' component={AddProductStickerScreen} options={{ title: t('printStickers.addProductSticker') }} />
          <Stack.Screen name='StickerPrinterSettings' component={StickerPrinterSettingsScreen} options={{ title: t('printStickers.printSettings') }} />

          <Stack.Screen name='Profile' component={ProfileScreen} options={{ title: t('profile.profile') }} />
          <Stack.Screen name='Salary' component={SalaryScreen} options={{ title: t('salary.salary') }} />
          <Stack.Screen name='SellerChecklist' component={SellerChecklistScreen} options={{ title: t('checklist.checklist') }} />
          <Stack.Screen name='Updates' component={UpdatesScreen} options={{ title: t('updates.updates') }} />

          <Stack.Screen name='CreateMarketingList' component={CreateMarketingListScreen} options={{ title: t('marketingLists.createMarketingList') }} />
          <Stack.Screen name='MarketingLists' component={MarketingListsScreen} options={{ title: t('marketingLists.marketingLists') }} />
          <Stack.Screen name='MarketingListDetail' component={MarketingListDetailScreen} options={{ title: t('marketingLists.marketingList') }} />
          <Stack.Screen name='ChooseProduct' component={ChooseProductScreen} options={{ title: t('marketingLists.chooseProduct') }} />
          
          <Stack.Screen name='Clients' component={ClientsScreen} options={{ title: t('clients.clients') }} />
          <Stack.Screen name='ClientDetail' component={ClientDetailScreen} options={{ title: t('clients.client') }} />

          <Stack.Screen name='SupplyOrders' component={SupplyOrdersScreen} options={{ title: t('supplyOrders.supplyOrders') }} />
          <Stack.Screen name='SupplyOrderDetail' component={SupplyOrderDetailScreen} options={{ title: t('supplyOrders.supplyOrder') }} />

          <Stack.Screen name='Stats' component={StatsScreen} options={{ title: t('stats.stats') }} />
          <Stack.Screen name='ShiftsStats' component={ShiftsStats} options={{ title: t('shift.shiftStats') }} />
          <Stack.Screen name='ProfitStats' component={ProfitStats} options={{ title: t('stats.profitStats') }} />
          <Stack.Screen name='SalesStats' component={SalesStats} options={{ title: t('salesHistory.salesStats') }} />
          <Stack.Screen name='RevisionStats' component={RevisionStats} options={{ title: t('revisions.revisionStats') }} />
          <Stack.Screen name='ProductStats' component={ProductStats} options={{ title: t('stats.productStats') }} />
          <Stack.Screen name='ComplexSaleStats' component={ComplexSaleStats} options={{ title: t('stats.complexSaleStats') }} />
          <Stack.Screen name='EditDailyStats' component={EditDailyStatsScreen} options={{ title: 'Edit Daily Stats' }} />

          <Stack.Screen name='Settings' component={SettingsScreen} options={{ title: t('settings.settings') }} />
          <Stack.Screen name='ProductCategories' component={ProductCategoriesScreen} options={{ title: t('settings.productCategories') }} />
          <Stack.Screen name='UniversalList' component={UniversalListScreen} options={{ title: '' }} />
          <Stack.Screen name='EditableList' component={EditableListScreen} options={{ title: '' }} />
          <Stack.Screen name='OrgDetail' component={OrgDetailScreen} options={{ title: '' }} />
          <Stack.Screen name='StoreDetail' component={StoreDetailScreen} options={{ title: '' }} />
          <Stack.Screen name='WalletDetail' component={WalletDetailScreen} options={{ title: '' }} />
          <Stack.Screen name='PaymentMethodDetail' component={PaymentMethodDetailScreen} options={{ title: '' }} />
          <Stack.Screen name='PurchaseMethodDetail' component={PurchaseMethodDetailScreen} options={{ title: '' }} />
          <Stack.Screen name='PriceTypes' component={PriceTypesScreen} options={{ title: '' }} />
          <Stack.Screen name='ProductModifiersDetail' component={ProductModifiersDetailScreen} options={{ title: '' }} />
          <Stack.Screen name='RoleDetail' component={RoleDetailScreen} options={{ title: '' }} />
          <Stack.Screen name='ProductUnitDetail' component={ProductUnitDetailScreen} options={{ title: '' }} />
          <Stack.Screen name='UserDetail' component={UserDetailScreen} options={{ title: '' }} />
          <Stack.Screen name='SupplierDetail' component={SupplierDetailScreen} options={{ title: t('supplier') }} />
          <Stack.Screen name='ChooseStore' component={ChooseStoreScreen} options={{ title: t('profile.chooseStore') }} />
          <Stack.Screen name='LoyaltySettings' component={LoyaltySettingsScreen} options={{ title: t('settings.loyaltySettings') }} />
          <Stack.Screen name='MarketplaceSettings' component={MarketplaceSettingsScreen} options={{ title: t('settings.marketplaceSettings') }} />
          <Stack.Screen name='PrintSettings' component={PrintSettingsScreen} options={{ title: t('settings.printSettings') }} />
          <Stack.Screen name='SaleSettings' component={SaleSettingsScreen} options={{ title: t('settings.saleSettings') }} />  

          <Stack.Screen name='Billing' component={BillingScreen} options={{ title: t('billingAndPayment') }} />
          <Stack.Screen name="Paywall" component={PaywallScreen} options={{ title: '' }} />

          <Stack.Screen name='ExportImport' component={ExportImportScreen} options={{ title: t('exportImport.exportImport') }} />
          <Stack.Screen name='SalesImport' component={SalesImportScreen} options={{ title: t('salesImport.title') }} />
          <Stack.Screen name='ManufactureImport' component={ManufactureImportScreen} options={{ title: t('manufactureImport.title') }} />
          <Stack.Screen name='ResetData' component={ResetDataScreen} options={{ title: t('resetData') }} />
          <Stack.Screen name='Misc' component={MiscScreen} options={{ title: t('misc') }} />
          <Stack.Screen name='DatabaseWriteLogs' component={DatabaseWriteLogsScreen} options={{ title: 'Database Write Logs' }} />
          <Stack.Screen name='Tests' component={DualWriteTestScreen} options={{ title: 'Dual Write Tests' }} />
          
          <Stack.Screen name='Legal' component={LegalScreen} options={{ title: t('settings.legal') }} />
          <Stack.Screen name='ApiTokens' component={ApiTokensScreen} options={{ title: t('apiTokens.title') }} />
          <Stack.Screen name='AgentDrafts' component={AgentDraftsScreen} options={{ title: t('apiDrafts.title') }} />
          <Stack.Screen name='AiAssistants' component={AiAssistantsScreen} options={{ title: t('aiAssistants.title') }} />
          <Stack.Screen name='ConnectAi' component={ConnectAiScreen} options={{ title: t('aiAssistants.consentTitle') }} />
        </Stack.Navigator>
      }
      {shouldShowFloatingButton() && <FloatingButtonWithModal productScreenAvailable={!paywallOnly} />}
    </>
  )
}
